import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      padding: [28, 0, 0],
      [theme.breakpoints.up("mobile")]: {
        padding: [31, 0, 0],
      },
      [theme.breakpoints.up("tablet")]: {
        padding: [41, 0, 0],
      },
    },
  }),
  { name: "Home" },
);
